import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchType } from '#/modules/search/types/SearchType';
import { LISTING_TYPE_PLURAL_HUMAN_NAME_MAP } from '#/utils/constants/general/listingTypePluralHumanNameMap';
import { LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE } from '#/utils/constants/general/listingTypePluralHumanNameMapTitle';

// noun = lowercase mid-phrase (`"Manager" jobs`); Noun = title-case sentence-start (`Jobs near X`).
// VOLOP uses the gerund "volunteering" (not "volunteer opportunities"), see sc-67359
export type MobileSearchNouns = { noun: string; Noun: string };

export function getMobileSearchNouns(
  i18n: I18nFn,
  type: SearchType,
): MobileSearchNouns {
  if (type === 'VOLOP')
    return {
      /* TRANSLATORS: mobile search noun, mid-phrase */
      noun: i18n('volunteering'),
      /* TRANSLATORS: mobile search noun, sentence-start */
      Noun: i18n('Volunteering'),
    };

  return {
    noun: LISTING_TYPE_PLURAL_HUMAN_NAME_MAP(i18n)[type],
    Noun: LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE(i18n)[type],
  };
}
